export const FIELDS_CHUNK_SIZE = 2;

export const COLUMN_WIDTH = 350;
